// extracted by mini-css-extract-plugin
export default {"list":"SupplierOrders__list___2wome","status":"SupplierOrders__status___lHqQX"};